import { requireRouteAudience } from '@services/router/routeAccess'
import { createFileRoute, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute('/_layout/_teacher-portal')({
    component: Outlet,
    beforeLoad: requireRouteAudience(['staff']),
})